export var CrmContactStatus;
(function (CrmContactStatus) {
    CrmContactStatus["NEW"] = "new";
    CrmContactStatus["ENGAGED"] = "engaged";
    CrmContactStatus["QUALIFIED"] = "qualified";
    CrmContactStatus["OPPORTUNITY"] = "opportunity";
    CrmContactStatus["CUSTOMER"] = "customer";
    CrmContactStatus["CHURNED"] = "churned";
})(CrmContactStatus || (CrmContactStatus = {}));
export var CrmDealStage;
(function (CrmDealStage) {
    CrmDealStage["DISCOVERY"] = "discovery";
    CrmDealStage["DEMO_COMPLETED"] = "demo_completed";
    CrmDealStage["PROPOSAL"] = "proposal";
    CrmDealStage["NEGOTIATION"] = "negotiation";
    CrmDealStage["CLOSED_WON"] = "closed_won";
    CrmDealStage["CLOSED_LOST"] = "closed_lost";
})(CrmDealStage || (CrmDealStage = {}));
//# sourceMappingURL=crm.js.map